import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=7e00ae18&scoped=true&"
import script from "./Support.vue?vue&type=script&lang=ts&"
export * from "./Support.vue?vue&type=script&lang=ts&"
import style0 from "./Support.vue?vue&type=style&index=0&id=7e00ae18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e00ae18",
  null
  
)

export default component.exports